"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536
};
exports.default = breakpoints;
